let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2tGNS")).then(() => parcelRequire('6MNnt'));